export default function accordion() {
  jQuery('.js-accordion').slideAccordion({
    opener: '.js-accordion-opener',
    slider: '.js-accordion-body-hidden',
    animSpeed: 300
  });
}